function groupBrandsByFirstLetter() {
    const container = document.querySelector('.brands-list__container');

    // Check if the container is found on the page
    if (!container) {
//        console.error('Container not found on the page.');
        return;
    }

    const brandNames = document.querySelectorAll('.brand-name');

    // Create an object to group brands by their first letter
    const groupedBrands = {};

    brandNames.forEach((brand) => {
        const firstLetter = brand.innerText.charAt(0).toUpperCase();

        if (groupedBrands[firstLetter]) {
            groupedBrands[firstLetter].push(brand.closest('.swiper-slide'));
        } else {
            groupedBrands[firstLetter] = [brand.closest('.swiper-slide')];
        }
    });

    // Sort the grouped brands alphabetically
    const sortedKeys = Object.keys(groupedBrands).sort();

    // Clear the container
    container.innerHTML = '';

    // Rebuild the container with sorted and grouped brands
    sortedKeys.forEach((key) => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('brand-group','mt-6', 'flex', 'flex-wrap', '-mx-2', 'xl:-mx-3');

        const letterHeader = document.createElement('div');
        letterHeader.classList.add('brand-letter', 'container-fluid');
        letterHeader.innerText = key;

        // Add the data-letter-anchor attribute to the letter header
        letterHeader.setAttribute('data-letter-anchor', `letter${key}`);

        wrapper.appendChild(letterHeader);
        groupedBrands[key].forEach((brand, index) => {
            // Add the data-letter-anchor attribute to each brand
            brand.setAttribute('data-letter-anchor', `letter${key}${index + 1}`);
            wrapper.appendChild(brand);
        });

        // Add the id attribute to the section
        wrapper.setAttribute('id', `letterAnchor${key}`);
        container.appendChild(wrapper);
    });

    // Set opacity 0.5 to letters without a group
    const alphabetLetters = document.querySelectorAll('.alphabet li');
    alphabetLetters.forEach((letter) => {
        const letterAnchor = letter.getAttribute('onclick').replace("scrollToAnchor('letter", '').replace("');", '');
        if (!groupedBrands[letterAnchor]) {
            letter.querySelector('span').classList.add('inactive');
        }
    });
}

// Call the function once the DOM is ready
document.addEventListener('DOMContentLoaded', groupBrandsByFirstLetter);

// Function to scroll to the corresponding section with the letter anchor
function scrollToAnchor(anchorId) {
    const targetSection = document.querySelector(`[data-letter-anchor="${anchorId}"]`);
    if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}

// Add event listeners to each letter element
const letters = document.querySelectorAll('.alphabet li');
letters.forEach(letter => {
    letter.addEventListener('click', function() {
        const anchorId = this.getAttribute('onclick').match(/'([^']+)'/)[1];
        scrollToAnchor(anchorId);
    });
});


window.addEventListener("load", function() {
    var element = document.getElementById('app-wrapper-template--22983529398606__1711463202b5b6a195');
    if (element) {
        element.style.height = 'auto';
        element.style.overflow = '';
    }
});







